import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import { useState } from "react";

const returnClassname = (isNotFeasible) => {
  return isNotFeasible ? "badge bg-danger me-2" : "badge bg-success me-2";
};

const returnClassnameBg = (isNotFeasible) => {
  return isNotFeasible
    ? { backgroundColor: "rgba(255, 99, 71, 0.2)" }
    : { backgroundColor: "rgba(144, 238, 144, 0.2)" };
};

const SiteInspectionTable = ({ SI = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const [quotationCache, setQuotationCache] = useState({});

  const goToView = (id) => {
    id = getId(id);
    navigate(`/client-site-inspection/view/${id}`);
  };

  const clampStyle = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  // const quotatioArea = (fullId) => {
  //   if (!fullId) return "";

  //   // If cached → return directly
  //   if (quotationCache[fullId]) {
  //     const data = quotationCache[fullId];
  //     return (
  //       <div className="text-start small ms-3">
  //         <span className="border-top mt-2 mb-2">
  //           <b className="fs-5">
  //             Bay: {data.bay_size || "N/A"}mtr | Span: {data.span_size || "N/A"}
  //             mtr
  //           </b>
  //         </span>
  //       </div>
  //     );
  //   }

  //   // else fetch
  //   const lastNumber = fullId.substring(fullId.lastIndexOf("/") + 1);

  //   performRequest("GET", `/quotations/getQuotationsByNum/${lastNumber}`)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         const info = res?.data?.input_info || {};

  //         setQuotationCache((prev) => ({
  //           ...prev,
  //           [fullId]: {
  //             bay_size: info.bay_size,
  //             span_size: info.span_size,
  //           },
  //         }));
  //       }
  //     })
  //     .catch((err) => CustomErrorResponse(err));

  //   // first render
  //   return <div className="text-muted small">Loading…</div>;
  // };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            <th>Sr.</th>
            <th className="d-none d-md-table-cell">Project / Area</th>
            <th className="d-none d-md-table-cell">Inspection Date</th>
            <th className="d-none d-md-table-cell w-33">Site Address</th>
            <th className="d-md-none d-sm-table-cell">
              Project/Inspection Date
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {SI?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            const isNotFeasible = item?.additionDetails?.markSiteNotFeasible;
            // const quotationNo =
            //   item?.quotationNumber || item?.aifQuotationNumber || "";

            // const lastPart = quotationNo.split("/").pop()?.trim();

            // const quotationData = quotations.find((q) => {
            //   const qLastPart = q?.quotationNumber?.split("/").pop()?.trim();

            //   return qLastPart === lastPart;
            // });

            return (
              <tr key={item?.siNumber} style={returnClassnameBg(isNotFeasible)}>
                <td>{Index}</td>
                <td className="d-none d-md-table-cell">
                  <span className={returnClassname(isNotFeasible)}></span>
                  {item?.clientDetails?.clientName || "N/A"}
                  {(item?.quotationNumber || item?.aifQuotationNumber) && (
                    <span>
                      {item?.quotationNumber || item?.aifQuotationNumber ? (
                        <div className="text-start small ms-3">
                          <span className="border-top mt-2 mb-2">
                            <b className="fs-5">
                              Bay:{" "}
                              {item?.quotationDetails?.input_info?.bay_size ||
                                "N/A"}
                              mtr | Span:{" "}
                              {item?.quotationDetails?.input_info?.span_size ||
                                "N/A"}
                              mtr
                            </b>
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </span>
                  )}
                </td>
                <td className="d-none d-md-table-cell">
                  {item?.newSiteInspection?.inspectionDate || "N/A"}
                  {/* {(item?.quotationNumber || item?.aifQuotationNumber) && (
                    <hr className="mt-1 p-0"></hr>
                  )} */}
                  <div>
                    {(item?.quotationNumber || item?.aifQuotationNumber) && (
                      <span className="border-top">
                        <b>
                          {item?.quotationNumber || item?.aifQuotationNumber}
                        </b>
                      </span>
                    )}
                  </div>
                </td>
                <td className="d-none d-md-table-cell w-33">
                  <p style={clampStyle}>
                    {item?.newSiteInspection?.siteAddressLine1 || "N/A"}
                  </p>
                </td>
                <td className="d-md-none d-sm-table-cell">
                  {item?.newSiteInspection?.inspectionDate || "N/A"}
                  <br />
                  <span>
                    <span className={returnClassname(isNotFeasible)}></span>
                    {item?.clientDetails?.clientName || "N/A"}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.siNumber)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SiteInspectionTable;
